"use client";

import { Heart, MoreVertical, Share2 } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "@/components/assets/button/button";
import { LeftSidebarToggle } from "@/components/layout/detail/leftSidebarToggle";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type DetailHeaderProps = {
  leftSidebarOpen: boolean;
  showDetail: boolean;
  onLeftSidebarChange: (open: boolean) => void;
  toggleLabel: string;
  headerActions?: ReactNode;
  defaultActions?: boolean;
  defaultActionsMenuItems?: Array<{
    label: string;
    onClick?: () => void;
  }>;
};

export function DetailHeader({
  leftSidebarOpen,
  showDetail,
  onLeftSidebarChange,
  toggleLabel,
  headerActions,
  defaultActions = true,
  defaultActionsMenuItems = [{ label: "Report" }, { label: "Copy" }],
}: DetailHeaderProps) {
  return (
    <header className="sticky top-0 z-10 flex shrink-0 items-center gap-2 border-blue-500 border-l-6 bg-linear-to-r from-gray-300 via-gray-200 to-gray-100 pt-1 pr-2 pl-2">
      <LeftSidebarToggle
        leftSidebarOpen={leftSidebarOpen}
        onLeftSidebarChange={onLeftSidebarChange}
        showDetail={showDetail}
        toggleLabel={toggleLabel}
      />
      {/* Right - Action Icons */}
      {headerActions ||
        (defaultActions && (
          <div className="ml-auto flex items-center rounded-full bg-gray-300/50">
            {/* Share Icon */}
            <Button
              iconBefore={<Share2 className="h-5 w-5" />}
              size="icon"
              variant="ghost"
            />

            {/* Heart Icon */}
            <Button
              iconBefore={<Heart className="h-5 w-5" />}
              size="icon"
              variant="ghost"
            />

            {/* 3 Dot Menu */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  iconBefore={<MoreVertical className="h-5 w-5" />}
                  size="icon"
                  variant="ghost"
                />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                {defaultActionsMenuItems.map((item, index) => (
                  <DropdownMenuItem key={index} onClick={item.onClick}>
                    {item.label}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        ))}
    </header>
  );
}
